module.exports = __webpack_public_path__ + "img/icon_0.a863480f.png";